// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__1boX0","topBottomGutter":"Layout_topBottomGutter__2BYTP"};